module.exports = __webpack_public_path__ + "static/3M_2024_Financial_Reporting-f7b12394011b0f4b73d12d7c59069a75.pdf";